import { names as personNames } from '@/common/interfaces/dto/Person';
import ImageItem from '@/common/interfaces//ImageItem';

export interface NewsletterSubscriptionPopupViewModel {
  TriggerTime: number;
  Title: string;
  SuppressPopup: boolean;
  ShowOnFirstPage: boolean;
  SubTitle: string;
  ButtonText: string;
  BottomText: string;
  PortraitImage: ImageItem;
  LandscapeImage: ImageItem;
  ThankYouText: string;
  GateName?: string
  AnalyticsData?: any;
}
export const formNames = {
  UserPerson: 'Person',
  UserEmail: 'Email',
  PostalCode: 'PostalCode',
  NewsletterOptin: 'NewsletterOptin',
};

export const names = {
  ...personNames,
  ...formNames,
};

